import * as React from "react";
import { Link, IfPermitted } from "components/common";
import { Alert, Col, Row } from "components/bootstrap";
import LicensesRoutes from "license/Routes";
const Status = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Sigma correlation rules are disabled" }, /* @__PURE__ */ React.createElement("p", null, "This is caused by the absence of a valid Security license. It is still possible to update this Event Definition, but no new Alerts and Events will be generated from it."), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "licenses:create" }, /* @__PURE__ */ React.createElement("p", null, "See ", /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }, "Licenses page"), " for details.")));
const SigmaCorrelationLicenseStatus = ({ licenseStatus: { status, missing }, summary = false }) => {
  if (!missing && status && status.valid) {
    return null;
  }
  if (summary) {
    return /* @__PURE__ */ React.createElement(Status, null);
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Status, null)));
};
export default SigmaCorrelationLicenseStatus;
